'use strict';

import _ from 'underscore';

export default function PartnerEditController(
  PartnerService,
  FlashService,
  SitesService,
  AdTypesFactory,
  PartnerUtilitiesService,
  $location,
  $q
) {
  var vm = this;
  vm.defaultSites = [];
  vm.exampleEditLink = exampleEditLink;
  vm.colorOptions = {
    format: 'rgb',
    alpha: false
  };

  vm.handleTypeChange = handleTypeChange;
  vm.RTB_VERSIONS = ['2.2', '2.3'];
  vm.save = save;
  vm.setLogo = setLogo;
  vm.siteSelected = siteSelected;

  initialize();

  return vm;

  function initialize() {
    vm.toggleSites = PartnerUtilitiesService.toggleById;

    PartnerService.get().then(function(partner) {
      vm.partner = partner;
    });

    SitesService.defaultSites().then(function(sites) {
      vm.defaultSites = sites;
    });

    vm.adTypes = AdTypesFactory.ALL_TYPES;
  }

  function siteSelected(site) {
    if (!vm.partner) {
      return false;
    }

    return !!_.findWhere(vm.partner.sites, { id: site.id });
  }

  function handleTypeChange() {
    if (vm.partner.partnerType === 'DSP') {
      vm.partner.rtbVersion = vm.partner.rtbVersion || vm.RTB_VERSIONS[0];
    } else {
      vm.partner.rtbVersion = null;
    }
  }

  function save() {
    var outcome = PartnerUtilitiesService.validatePartnerOutcome(vm.partner);

    if (outcome.successful) {
      return PartnerService.update(vm.partner).then(
        function(partner) {
          vm.partner = partner;
          FlashService.push('success', 'Your changes have been saved.');
        }.bind(vm),
        function(errorResponse) {
          if (errorResponse.status === 403) {
            FlashService.push(
              'error',
              "You don't have permission to edit this partner."
            );
          } else {
            vm.errors = errorResponse.data.errors;
            FlashService.push('error', 'Something went wrong.');
          }
        }
      );
    } else {
      FlashService.push('error', outcome.errors.join(', '));

      return $q.reject();
    }
  }

  function setLogo(file) {
    vm.partner.newLogo = file;
  }

  function exampleEditLink() {
    var subdomain = $location.search()['subdomain'];

    if (subdomain) {
      return '/examples/edit' + '?subdomain=' + subdomain;
    } else {
      return '/examples/edit';
    }
  }
}

PartnerEditController.$inject = [
  'PartnerService',
  'FlashService',
  'SitesService',
  'AdTypesFactory',
  'PartnerUtilitiesService',
  '$location',
  '$q'
];
